import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ContentObject,
  Thread,
  ThreadGroup,
} from '../../interfaces/copilotChat';
import { ChatMessage } from '@ant-design/pro-chat';

interface AdminAgentState {
  groupedThreads: ThreadGroup[];
  threads: Thread[];
  newThreadId: string;
  chatMessages: ChatMessage[];
  result: ContentObject[] | null;
}

const getInitialState = () => {
  return {
    groupedThreads: [],
    threads: [],
    newThreadId: '',
    chatMessages: [],
    result: null,
  };
};

const initialState: AdminAgentState = getInitialState();

const adminAgentSlice = createSlice({
  name: 'adminAgent',
  initialState,
  reducers: {
    resetAdminAgent: () => {
      return initialState;
    },
    setGroupedThreads: (state, action: PayloadAction<ThreadGroup[]>) => {
      state.groupedThreads = action.payload;
    },
    setThreads: (state, action: PayloadAction<Thread[]>) => {
      state.threads = action.payload;
    },
    setNewThreadId: (state, action: PayloadAction<string>) => {
      state.newThreadId = action.payload;
    },
    setChatMessages: (state, action: PayloadAction<ChatMessage[]>) => {
      state.chatMessages = action.payload;
    },
    setResult: (state, action: PayloadAction<ContentObject[] | null>) => {
      state.result = action.payload;
    },
  },
});

export const {
  resetAdminAgent,
  setGroupedThreads,
  setThreads,
  setNewThreadId,
  setChatMessages,
  setResult,
} = adminAgentSlice.actions;

export default adminAgentSlice.reducer;
